
<div class="flex justify-content-center p-0">
    <div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
        <div class="flex justify-content-center p-0">
            <div class="p-col-12 p-md-6 p-lg-3 p-0">
                <h3 >{{ 'h3.audit' | translate }}</h3>
            </div>
        </div>

        <div *ngIf="selectedZone && auditResponse">
            <p>
                {{ 'h5.countType' | translate }}: 
                <span [ngStyle]="{'color': auditResponse[itemList].cycleCountTypeC == countType.RECOUNT ? 'red' : 'black'}">
                    {{auditResponse[itemList].cycleCountTypeC == 'R'? this.translate.instant('h5.recount') : this.translate.instant('h5.count')}}
                </span>
            </p>
        </div>

        <div class="pb-0">
            <label>{{ 'h5.zone' | translate }}</label>
            <p-select
                [options]="returnedZones$ | async"
                [(ngModel)]="selectedZone"
                placeholder="{{ 'h5.selectZone' | translate }}"
                (ngModelChange)="checkDropdownValid()"
                optionLabel="zoneC"
                [showClear]="true"
                [style]="{'minWidth' : '100%'}">
            </p-select>
        </div>

        <div class="card pl-3 pb-2 pt-0" *ngIf="selectedZone && auditResponse">
            <div class="p-1 z-0">
                <h5>{{ 'h5.quantityToAudited' | translate }}: <span class="text-sm opacity-60 ">{{ itemScreen}} / {{ auditResponse.length }}</span></h5>
                <h5>{{ 'h5.part' | translate }}: <span class="text-sm opacity-60 ">{{ auditResponse[itemList].partName }}</span></h5>
                <h5 *ngIf="auditResponse[itemList].conversionPartName">{{ (auditResponse[itemList].convertedPartGSPNF === 'Y' ? 'h5.newPart' : 'h5.oldPart') | translate }}: <span class="text-sm opacity-60 ">{{ auditResponse[itemList].conversionPartName }}</span></h5>
                <h5>{{ 'h5.description' | translate }}: <span class="text-sm opacity-60 ">{{ auditResponse[itemList].description | uppercase }}</span></h5>
				<h5>{{ 'h5.staging' | translate }}: <span class="text-sm opacity-60 ">{{ auditResponse[itemList].location | uppercase }}</span></h5>
            </div>
        </div>

        <div *ngIf="!selectedZone && !auditResponse && currentZoneName"
            class="p-col-12 p-md-6 p-lg-3">
            <h5>{{ 'h3.countFinished' | translate }} {{ currentZoneName }}</h5>
        </div>

        <div class="pb-0">
            <label>{{ 'h5.location' | translate }}</label>
            <input type="text" minlength="1" maxlength="16" pInputText tabindex="-1"
            [ngClass]="{focusField: inputFields[0].focus}"
            [disabled]="!selectedZone" [(ngModel)]="inputFields[0].value"
            id="inputFields[0].id" (keydown.enter)="checkLocation()" (ngModelChange)="resetQtd()">
        </div>

        <div class="pb-0">
            <label>{{ 'h5.quantity' | translate }}</label>
            <input type="number" pInputText min="0" id="{{ inputFields[1].id }}" tabindex="-1"
                [disabled]="!inputFields[0].valid" (keydown.enter)="validQuantity()"
                [(ngModel)]="inputFields[1].value" (ngModelChange)="inputFields[1].valid=false"
                onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}">
        </div>

        <div class="flex justify-content-center p-0">
            <div class="p-col-12 p-md-6 p-lg-3 p-0">
                <button pButton class="skipButton button submit" (click)="skipCountingPart()" [disabled]="skipButtonDisable || !selectedZone">{{ 'button.skip' | translate }}</button>
                <button pButton class="saveButton button submit" (click)="saveCountingPart()" [disabled]="checkInputs()">{{ 'button.save' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<input-generic
    [inputFields] = "inputFields"
    (eventEmitter) = "executeAction($event)">
</input-generic>

